import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  InfoCircleOutlined
} from "@ant-design/icons";
import { t } from "i18next";
import moment from "moment";
import {
  getTotalEmployee,
  getAbsentEmployees,
  getSummaryRequest,
  getLeavesRequest
} from "services/dashboard";
import {
  Card,
  Row,
  Col,
  Button,
  Tabs,
  Pagination,
  Spin,
  Table
} from "common/elements";
import EmployeeProfile from "components/Employee/ViewProfile";
import { Util } from "common/util";
import { getHostURl } from "services/core";
import { getActingProfile } from "services/employee";

const { TabPane } = Tabs;

function CardIcon({path, title}) {
  return <div style={{ width: 60, height: 60, padding: 7, borderRadius: 4, display: "flex", justifyContent: "center", alignItems: "center" }}>
  <img alt={title} src={path} style={{ objectFit: "cover", height: 50 }} />
</div>
}

export default function Home() {
  const [leavesRequest, setLeavesRequest] = useState({ data: [], pagination: { total: 0 } });
  const [totalEmployee, setTotalEmployee] = useState({ total: 0, totalNewHire: 0, resignedEmployee: 0, contractExpired: 0 });
  const [absentEmployees, setAbsentEmployees] = useState({
    data: [],
    pagination: { total: 0 },
  });
  const [summaryRequest, setSummaryRequest] = useState([
    {
      count: "0",
    },
    {
      count: "0",
    },
    {
      count: "0",
    },
    {
      count: "0",
    },
  ]);

  const [absentEmployeeLoaing, setAbsentEmployeeLoaing] = useState(false);
  const [leavesRequestLoading, setLeavesRequestLoading] = useState(false);
  const queryParams = new URLSearchParams(document.location.search);
  const util = new Util();

  useEffect(() => {
    getActingProfile(Util.getInstance().getCurrentUser().id)
    .then(response => {
      if (response) {
        localStorage.setItem("IN_ACTING", true);
      }
    }).catch(() => localStorage.removeItem("IN_ACTING"));
  }, []);
  const columns = [
    {
      title: t("text_employee_name"),
      dataIndex: "id",
      key: "id",
      render: (id, record) => {
        return (
          <div
            className="profile"
            style={{ display: "flex", alignItems: "center" }}
          >
            {record.photo !== null ? (
              <img
                src={`${getHostURl()}/public/uploads/profile/${record.photo}?v=${Date.now()}`}
                alt="profile"
                style={{
                  height: 40,
                  width: 40,
                  borderRadius: 50,
                  outline: "1px solid #dddddd",
                  objectFit: "cover",
                  marginTop: 7,
                }}
              />
            ) : (
              <div id="borderLogoLetter">
                <span>
                  {record.employeeName &&
                    util.getFristCharater(record.employeeName)}
                </span>
              </div>
            )}
            <span style={{ marginLeft: "20px" }}>
              {record.employeeName && record.employeeName}
            </span>
          </div>
        );
      },
    },
    {
      title: t("text_from_date"),
      dataIndex: "start",
      key: "start",
      render: (start) => start && moment(start).format("DD/MM/YYYY hh:mm A"),
    },
    {
      title: t("text_to_date"),
      dataIndex: "end",
      key: "end",
      render: (end) => end && moment(end).format("DD/MM/YYYY hh:mm A"),
    },
    {
      title: t("text_type"),
      dataIndex: "leaveType",
      key: "leaveType",
    },
    {
      title: t("text_status"),
      dataIndex: "status",
      key: "status",
      render: (status, record) => {
        return (
          <div>
            <Button
              style={{
                background: "rgb(240 173 78 / 34%)",
                color: "#F0AD4E",
                fontSize: 14,
                outline: "none !important",
                borderRadius: 50,
                border: "none",
                width: 85,
                height: 25,
                padding: 0,
              }}
            >
              {t("text_pending")}
            </Button>
          </div>
        );
      },
    },
  ];

  const navigate = useNavigate();

  let defaultCurrent = 1;
  let defaultPageSize = 5;
  let defaultCurrentRequestForApproval = 1;
  let defaultPageSizeRequestForApproval = 4;

  const onClickInfoCircleOutlined = (link) => {
    navigate(link);
  };

  const onChangePagination = (page, pageSize) => {
    const queryParams = new URLSearchParams(document.location.search);
    queryParams.set("current", page);
    queryParams.set("size", pageSize);
    Util.getInstance().pushParamsToURL("/", queryParams.toString());
    getAbsentEmployee();
  };

  const onChangeRequestforApprovalPagination = (page, pageSize, paginationType) => {
    const queryParams = new URLSearchParams(document.location.search);

    switch (paginationType) {
      case 0:
        queryParams.set("currentLeave", page);
        queryParams.set("sizeLeave", pageSize);
        break;
      case 1:
        queryParams.set("currentOvertime", page);
        queryParams.set("sizeOvertime", pageSize);
        break;
      case 2:
        queryParams.set("currentLate", page);
        queryParams.set("sizeLate", pageSize);
        break;
      case 3:
        queryParams.set("currentEarly", page);
        queryParams.set("sizeEarly", pageSize);
        break;
      default:
        break;
    }

    Util.getInstance().pushParamsToURL("/", queryParams.toString());
    fetchRequestforApproval(paginationType);
  };

  const getAbsentEmployee = () => {
    const queryParams = new URLSearchParams(document.location.search);
    let limit = defaultPageSize;
    let current = defaultCurrent;
    let offset = 0;
    if (queryParams.has("size")) {
      limit = queryParams.get("size");
    }
    if (queryParams.has("current")) {
      current = queryParams.get("current");
    }

    offset = (current - 1) * limit;
    setAbsentEmployeeLoaing(true);
    getAbsentEmployees(offset, limit)
      .then((response) => {
        if (response) {
          setAbsentEmployees(response);
        }
      })
      .catch(error => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
      })
      .finally(() => {
        setAbsentEmployeeLoaing(false);
      });
  };

  const fetchSummaryRequest = () => {
    getSummaryRequest().then((response) => {
      if (response) {
        setSummaryRequest(response);
      }
    }).catch(error => {
      if (error.response.status === 403) {
        localStorage.removeItem("ACCESS_TOKEN");
        navigate("/signin");
      }
    })
  };

  const fetchRequestforApproval = (key) => {
    const queryParams = new URLSearchParams(document.location.search);
    let limit = defaultPageSizeRequestForApproval;
    let current = defaultCurrentRequestForApproval;
    let offset = 0;

    if (key === 0) {
      if (queryParams.has("sizeLeave")) {
        limit = queryParams.get("sizeLeave");
      }
      if (queryParams.has("currentLeave")) {
        current = queryParams.get("currentLeave");
      }

      offset = (current - 1) * limit;
      setLeavesRequestLoading(true);
      getLeavesRequest(offset, limit)
        .then((response) => {
          if (response) {
            setLeavesRequest(response);
          }
        }).catch(error => {
          if (error.response.status === 403) {
            localStorage.removeItem("ACCESS_TOKEN");
            navigate("/signin");
          }
        })
        .finally(() => {
          setLeavesRequestLoading(false);
        });
    }
    if (key === 1) {
      if (queryParams.has("sizeOvertime")) {
        limit = queryParams.get("sizeOvertime");
      }
      if (queryParams.has("currentOvertime")) {
        current = queryParams.get("currentOvertime");
      }
    }
  };

  const onChangeTabPane = (key) => {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("TabPaneKey", key);
    if (key !== "0") {
      queryParams.delete("sizeLeave");
      queryParams.delete("currentLeave");
    }
    if (key !== "1") {
      queryParams.delete("sizeOvertime");
      queryParams.delete("currentOvertime");
    }
    if (key !== "2") {
      queryParams.delete("sizeLate");
      queryParams.delete("currentLate");
    }
    if (key !== "3") {
      queryParams.delete("sizeEarly");
      queryParams.delete("currentEarly");
    }
    util.pushParamsToURL("/", queryParams.toString());
    fetchSummaryRequest();
    fetchRequestforApproval(parseInt(key));
  };

  const profile = JSON.parse(localStorage.getItem("ACCESS_TOKEN"));
  // const roleCode = profile?.roleCode;
  const profileId = profile?.profile.id;
  queryParams.set("id", profileId);

  useEffect(() => {
    getTotalEmployee().then((response) => {
      if (response) {
        setTotalEmployee(response);
      }
    }).catch(error => {
      if (error.response.status === 403) {
        localStorage.removeItem("ACCESS_TOKEN");
        navigate("/signin");
      }
    });

    getAbsentEmployee();
    fetchSummaryRequest();
    fetchRequestforApproval(0);
    fetchRequestforApproval(1);
    fetchRequestforApproval(2);
    fetchRequestforApproval(3);
    // eslint-disable-next-line
  }, []);

  const onRow = (record, index, link) => {
    return {
      onClick: () => {
        navigate(`${link}?leaveId=${record.id}`);
      },
    };
  };

  return (
    <>
      {
        Util.getInstance().hasPermission("view", "dashboard") ?
          <div id="bgDashboard">
            <div id="navDashboard">
              <Row>
                <Col span={12}>
                  <div className="nav-left-dashboard">
                    <h3>Payroll & HRIS</h3>
                    <h5>{t("text_heres_your_analytic_details")}</h5>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="site-card-wrapper">
              <Row gutter={[16, 16]}>
                <Col lg={6}>
                  <div id="itemDashboard">
                    <Card bordered={false}>
                      <div id="headerItem">
                        <div className="icon-left">
                          <CardIcon path="/total-employee.png" title="Total Employee" />
                          <div className="total-employee">
                            {t("text_total_employee")}
                          </div>
                          <div style={{display: "flex", alignItems: "center"}}>
                            <div className="result-employee">
                              <div>{totalEmployee.total}</div>
                            </div>
                            <div style={{marginLeft: 30}}>Male: {totalEmployee.male}</div>
                            <div style={{marginLeft: 15}}>Female: {totalEmployee.female}</div>
                          </div>
                        </div>
                        <div className="icon-right">
                          <div className="btn-infos-dashboard">
                            <Button
                              title={"Info"}
                              className="info"
                              icon={<InfoCircleOutlined />}
                              onClick={() =>
                                onClickInfoCircleOutlined("/employees")
                              }
                              style={{
                                margin: "6px 0",
                                minWidth: 44,
                                border: "none",
                                color: "#000000",
                                opacity: 0.45,
                                padding: 0,
                                background: "none",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>
                </Col>
                <Col lg={6}>
                  <div id="itemDashboard">
                    <Card bordered={false}>
                      <div id="headerItem">
                        <div className="icon-left">
                          <CardIcon path="/new-hire.png" title="New Hire" />
                          <span className="total-employee">
                            {t("text_new_hire")}
                          </span>
                          <span className="result-employee">
                            {totalEmployee.totalNewHire}
                          </span>
                        </div>
                        <div className="icon-right">
                          <div className="btn-infos-dashboard">
                            <Button
                              title={"Info"}
                              className="info"
                              icon={<InfoCircleOutlined />}
                              onClick={() =>
                                onClickInfoCircleOutlined("/employees?newHire=true")
                              }
                              style={{
                                margin: "6px 0",
                                minWidth: 44,
                                border: "none",
                                color: "#000000",
                                opacity: 0.45,
                                padding: 0,
                                background: "none",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>
                </Col>
                <Col lg={6}>
                  <div id="itemDashboard">
                    <Card bordered={false}>
                      <div id="headerItem">
                        <div className="icon-left">
                          <CardIcon path="/resign-employee.png" title="Resign Employee" />
                          <span className="total-employee">
                            Resigned Employees
                          </span>
                          <span className="result-employee">
                            {totalEmployee.resignedEmployee}
                          </span>
                        </div>
                        <div className="icon-right">
                          <div className="btn-infos-dashboard">
                            <Button
                              title={"Info"}
                              className="info"
                              icon={<InfoCircleOutlined />}
                              onClick={() => onClickInfoCircleOutlined("/employees?isResigned=true")}
                              style={{
                                margin: "6px 0",
                                minWidth: 44,
                                border: "none",
                                color: "#15c",
                                opacity: 0.45,
                                padding: 0,
                                background: "none",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>
                </Col>
                <Col lg={6}>
                  <div id="itemDashboard">
                    <Card bordered={false}>
                      <div id="headerItem">
                        <div className="icon-left">
                          <CardIcon path="/contract-expire.png" title="Contract Expire" />
                          <span className="total-employee">
                            Contract Expired
                          </span>
                          <span className="result-employee">
                            {totalEmployee.contractExpired}
                          </span>
                        </div>
                        <div className="icon-right">
                          <div className="btn-infos-dashboard">
                            <Button
                              title={"Info"}
                              className="info"
                              icon={<InfoCircleOutlined />}
                              onClick={() =>
                                onClickInfoCircleOutlined("/employees?contractExpired=true")
                              }
                              style={{
                                margin: "6px 0",
                                minWidth: 44,
                                border: "none",
                                color: "#000000",
                                opacity: 0.45,
                                padding: 0,
                                background: "none",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>
                </Col>
              </Row>
              <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
                <Col span={8}>
                  <div id="absentEmployee">
                    <Card bordered={false}>
                      <div className="title">
                        <span>{t("text_absent_employees")}</span>
                      </div>
                      {absentEmployeeLoaing ? (
                        <Spin
                          spinning={absentEmployeeLoaing}
                          style={{
                            height: "253px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        />
                      ) : (
                        absentEmployees.data.map((value) => {
                          const currentDay = moment().format("YYYY-MM-DD");
                          const end = moment(value.end);
                          const start = moment(value.start);
                          const diffCurrentDay = start.diff(currentDay, "days");
                          const diffEndDate = end.diff(start, "days");
                          return (
                            <div id="mainListAsent">
                              <Row>
                                <Col span={20}>
                                  <div id="mainList">
                                    {value.photo !== null ? (
                                      <div
                                        style={{
                                          height: 43,
                                          width: 43,
                                          borderRadius: 50,
                                          objectFit: "cover",
                                          border: "2px solid #dddddd",
                                          marginTop: 7
                                        }}
                                      >
                                        <img
                                          src={`${getHostURl()}/public/uploads/profile/${value.photo}?v=${Date.now()}`}
                                          alt="profile"
                                          style={{
                                            height: 40,
                                            width: 40,
                                            borderRadius: 50,
                                            objectFit: "cover",
                                            border: "2px solid #fff",
                                          }}
                                        />
                                      </div>
                                    ) : (
                                      <div id="borderLogoLetter">
                                        <span>
                                          {value.employeeName &&
                                            util.getFristCharater(value.employeeName)}
                                        </span>
                                      </div>
                                    )}
                                    <div className="text-descrip">
                                      <ul>
                                        <li className="title-list-dashboard">
                                          {value.employeeName && value.employeeName}
                                        </li>
                                        <li className="date-list-dashboard">
                                          {diffCurrentDay === 0 && diffEndDate === 0
                                            ? t("text_today")
                                            : diffCurrentDay === 1 &&
                                              diffEndDate === 0
                                              ? t("text_tomorrow")
                                              : diffCurrentDay === 0
                                                ? `${t("text_today")} - ${moment(
                                                  value.end
                                                ).format("DD MMM")}`
                                                : `${moment(value.start).format(
                                                  "DD MMM"
                                                )} - ${moment(value.end).format(
                                                  "DD MMM"
                                                )}`}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </Col>
                                <Col span={4}>
                                  <div id="btnStatusDashboard">
                                    <Button>{t("text_approved")}</Button>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          );
                        })
                      )}

                      {absentEmployees.pagination?.total > 5 && (
                        <div id="mainPagination">
                          <div id="pagonationListDashboard">
                            <Pagination
                              defaultCurrent={
                                queryParams.has("current")
                                  ? parseInt(queryParams.get("current"))
                                  : 1
                              }
                              defaultPageSize={defaultPageSize}
                              total={absentEmployees.pagination?.total}
                              onChange={onChangePagination}
                            />
                          </div>
                        </div>
                      )}
                    </Card>
                  </div>
                </Col>
                <Col span={16}>
                  <div id="requestForApproval">
                    <Card bordered={false}>
                      <div className="title">
                        <span>{t("text_request_for_approval")}</span>
                      </div>
                      <div id="tab-request-approval">
                        <Tabs
                          onChange={onChangeTabPane}
                          defaultActiveKey={
                            queryParams.has("TabPaneKey")
                              ? queryParams.get("TabPaneKey")
                              : "0"
                          }
                        >
                          <TabPane
                            onChange={onChangeTabPane}
                            tab={[
                              <>
                                {summaryRequest[0]["count"] !== "0" && (
                                  <div className="number-noti-tab-request">
                                    {summaryRequest[0]["count"]}
                                  </div>
                                )}
                                <span>{t("text_leaves")}</span>
                              </>,
                            ]}
                            key="0"
                          >
                            <div
                              className="display-for-approval"
                              id="tableRequestForApproval"
                            >
                              <Table
                                bordered
                                dataSource={leavesRequest.data}
                                rowKey={(record) => `${record.id}`}
                                columns={columns}
                                pagination={false}
                                loading={leavesRequestLoading}
                                onRow={(record, index) =>
                                  onRow(record, index, "/leaves")
                                }
                              />
                              {leavesRequest.pagination.total > 4 && (
                                <div id="mainPagination">
                                  <div id="pagonationListDashboard">
                                    <Pagination
                                      current={
                                        queryParams.has("currentLeave")
                                          ? parseInt(queryParams.get("currentLeave"))
                                          : 1
                                      }
                                      defaultPageSize={
                                        defaultPageSizeRequestForApproval
                                      }
                                      total={leavesRequest.pagination.total}
                                      onChange={(page, pageSize) =>
                                        onChangeRequestforApprovalPagination(
                                          page,
                                          pageSize,
                                          0
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </TabPane>
                        </Tabs>
                      </div>
                    </Card>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          :
          <EmployeeProfile employeeId={Util.getInstance().getCurrentUser().id} />
      }
    </>

  );
}
